import { render, staticRenderFns } from "./AtributGaji.vue?vue&type=template&id=62206efe&scoped=true"
import script from "./AtributGaji.vue?vue&type=script&lang=js"
export * from "./AtributGaji.vue?vue&type=script&lang=js"
import style0 from "./AtributGaji.vue?vue&type=style&index=0&id=62206efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62206efe",
  null
  
)

export default component.exports